import * as fromDatatype from '../../../../models/datatype-library';

export class OutstandingAgingDto {

    entity_guid: fromDatatype.GuidDataFieldInterface;
    customer_code: fromDatatype.VarcharDatatypeInterface;
    supplier_code: fromDatatype.VarcharDatatypeInterface;
    employee_code: fromDatatype.VarcharDatatypeInterface;
    merchant_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;;
    month1: fromDatatype.VarcharDatatypeInterface;;
    month2: fromDatatype.VarcharDatatypeInterface;;
    month3: fromDatatype.VarcharDatatypeInterface;;
    month4: fromDatatype.VarcharDatatypeInterface;;
    month5: fromDatatype.VarcharDatatypeInterface;;
    month6: fromDatatype.VarcharDatatypeInterface;;
    month7: fromDatatype.VarcharDatatypeInterface;;
    total_doc_open: fromDatatype.NumericDatatypeInterface;
    total_arap_bal: fromDatatype.NumericDatatypeInterface;
}